exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-layout-header{z-index:100;padding:0 15px}.ant-layout-header .anticon{line-height:inherit}.patient-info{text-align:center;margin-top:20px;margin-bottom:20px}.patient-info img{margin-bottom:5px;width:100px;height:100px;border-radius:100%}#root,.ant-layout{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/global.scss
// module id = 593
// module chunks = 0